import axios from "axios";

export const SEG_TOKEN_KEY = "pgp_seg_token";

const segApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

segApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(SEG_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default segApi;
